<template>
    <div class="verify-login" :style="wrapperStyle" ref="VerifyLoginRef">
        <div v-if="x > 2 && !status" class="moved-block" :style="{ width: `${x}px`, background: `${primaryColor}` }" />
        <div v-else class="content">{{ status ? '验证通过' : '请按动滑块,拖至最右' }}</div>
        <img v-if="isMobile" class="block" :src="blockSrc" :draggable="false" :style="blockStyle" @touchstart="handleMouseDown" />
        <img v-else class="block" :src="blockSrc" :draggable="false" :style="blockStyle" @mousedown="handleMouseDown" />
    </div>
</template>

<script>
import checkedIcon from '@/assets/img/login/checked-icon.png';
import checkedSuccess from '@/assets/img/login/checked-success.png';

export default {
    data() {
        return {
            x: 2,
            status: false,
            mouseDownX: 0,
            isMobile: true,
        };
    },
    props: {
        width: { default: 400 },
        height: { default: 40 },
        primaryColor: { default: '#4a79f1' },
    },
    computed: {
        blockSrc() {
            return this.status ? checkedSuccess : checkedIcon;
        },
        wrapperStyle() {
            return {
                width: `${this.width}px`,
                height: `${this.height}px`,
                color: this.status ? '#FFF' : '#333',
                backgroundColor: this.status ? this.primaryColor : '#EEEEEE',
            };
        },
        blockStyle() {
            return {
                left: `${this.x}px`,
                width: `${this.height - 4}px`,
                height: `${this.height - 4}px`,
            };
        },
    },
    created() {
        this.isMobile = window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i) ? true: false
    },
    methods: {
        /* 鼠标按下去 */
        handleMouseDown(e) {
            if (this.status) return;
            if(this.isMobile) {
                this.mouseDownX = e.changedTouches[0].pageX
                window.addEventListener('touchend', this.handleMouseUp);
                window.addEventListener('touchmove', this.onListenMouseMove);
            } else {
                this.mouseDownX = e.pageX;
                window.addEventListener('mouseup', this.handleMouseUp);
                window.addEventListener('mousemove', this.onListenMouseMove);
            }
        },
        /* 鼠标抬起 */
        handleMouseUp() {
            if (this.status) return;
            this.x = 2;
            this.mouseDownX = 0;
            this.removeListen();
        },
        /* 监听滑动 */
        onListenMouseMove(e) {
            let moveX;
            let moveScope;
            if(this.isMobile) {
                moveX = e.changedTouches[0].pageX - this.mouseDownX;
                moveScope = this.width - this.height;
            } else {
                moveX = e.pageX - this.mouseDownX;
                moveScope = this.width - this.height;
            }
            

            // 触发最大距离
            if (moveX >= moveScope) {
                this.status = true;
                this.x = moveScope;
                this.removeListen();
                setTimeout(() => {
                    this.$emit('success');
                }, 500);
                return;
            }

            // 触发最小距离
            if (moveX <= 0) {
                this.x = 2;
                this.status = false;
                return;
            }

            // 正常拖转
            this.x = moveX;
        },
        /* 移除监听 */
        removeListen() {
            if(this.isMobile) {
                window.removeEventListener('touchend', this.handleMouseUp);
                window.removeEventListener('touchmove', this.onListenMouseMove);
            } else {
                window.removeEventListener('mouseup', this.handleMouseUp);
                window.removeEventListener('mousemove', this.onListenMouseMove);
            }
            
        },
        /* 重置滑块 */
        resetStatus() {
            this.x = 2;
            this.status = false;
        },
    },
};
</script>

<style lang="scss">
.verify-login {
    width: 400px;
    height: 40px;
    border-radius: 6px;
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
    .content {
        font-size: 14px;
    }
    .moved-block {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        border-radius: 6px;
    }
    .block {
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 6px;
        position: absolute;
        top: 2px;
    }
}
</style>
